<template>
  <div class="pop">
    <span class="close" @click="popClose">x</span>
    <div class="con-tel" v-show="!isHasTel">
      <p>请拨打021-20219999或留下手机号码了解详情，我们将有工作人员与您联系。</p>
      <div class="input-group">
        <em>手机号</em>
        <input type="tel" placeholder="请输入手机号码" v-model="tel">
        <span :class="{disable: isDisable}" @click="getCode">{{isDisable ? count+ 's重新获取' : '获取验证码'}}</span>
      </div>
      <div class="input-group">
        <em>验证码</em>
        <input type="text" placeholder="请输入短信验证码" v-model="captcha">
      </div>
      <div class="con-btm">
        <span class="btn" @click="bindTel">参与试运行</span>
      </div>
    </div>
    <div class="con-thanks" v-show="isHasTel">
      <p>感谢您的参与！<br>工作人员将通过021-20219999与您取得联系，请耐心等待!</p>
       <div class="con-btm">
        <span class="btn" @click="popClose">完成</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isDisable: false,
      count: 10,
      tel: '',
      captcha: ''
    }
  },
  props: ['isHasTel'],
  methods: {
    async getCode () {
      if(!this.$validate.checkPhone(this.tel)){
        this.$global.alert('手机号码格式不正确')
        return false
      }
      if(this.isDisable) {
        return false
      }
      let res = await this.$get('/product/captcha335Sms',{mobile: this.tel})
      if (res.code === 0) {

      } else {
        this.$global.alert(res.msg)
      }
      this.isDisable = true
      this.count--
      let timer = setInterval(()=>{
        this.count--
        if(this.count === 0) {
          this.isDisable = false
          this.count = 10
          clearInterval(timer)
        }
      },1000)
    },
    popClose () {
      this.$emit('close', false)
    },
    async bindTel () {
      if(!this.$validate.checkPhone(this.tel)){
        this.$global.alert('手机号码格式不正确')
        return false
      }
      let res = await this.$get('/product/check335Sms',{mobile: this.tel, captcha: this.captcha})
      if (res.code === 0) {
        this.isHasTel = true
      } else {
        this.$global.alert(res.msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div, p, input, span{box-sizing: border-box;}
.pop{
  width: 500px;
  height: 320px;
  background: #fff;
  border-radius: 20px;
  padding: 0px 0 20px;
  position: fixed;
  left: 50%;
  margin-left: -250px;
  top: 50%;
  margin-top: -160px;
  z-index: 2;
  border: 1px solid #0170ff;
  padding-top: 40px;
  .close{
    font-size: 30px;
    color: #7f7f7a;
    display: block;
    width: 30px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    background: #eee;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
  p{
    font-size: 24px;
    color: #000;
    line-height: 36px;
    margin: 0 30px 20px;
  }
  .input-group{
    overflow: hidden;
    color: #808080;
    font-size: 20px;
    margin: 0 0 20px 30px;
    em, input, span{
      float: left;
    }
    em{
      margin-right: 10px;
    }
    input{
      padding: 3px 10px;
      height: 32px;
      border: 1px solid #cdcdcd;
      width: 240px;
      margin-right: 10px;
      border-radius: 6px;
      font-size: 18px;
    }
    span{
      width: 116px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background: #0170ff;
      border-radius: 20px;
      font-size: 18px;
      cursor: pointer;
      &.disable{
        pointer-events: none;
        background: #666;
      }
    }
  }
  .con-btm{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 20px;
    border-top: 1px solid #cacaca;
    .btn{
      width: 180px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      background: #0170ff;
      border-radius: 20px;
      font-size: 18px;
      display: block;
      margin: 20px auto 0;
      cursor: pointer;
    }
  }
  .con-thanks{
    padding-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/PartakePop.vue